import CtaCard from './CtaCard'

export default CtaCard
